import type React from 'react';
import { Button } from './ui/button';

interface PublicHeaderProps {
  onSignIn?: () => void;
  showSignIn?: boolean;
  onBack?: () => void;
  showBack?: boolean;
}

export const PublicHeader: React.FC<PublicHeaderProps> = ({
  onSignIn,
  showSignIn = true,
  onBack,
  showBack = false,
}) => {
  return (
    <header className="border-b border-border/40 backdrop-blur-sm bg-background/80">
      <div className="max-w-6xl mx-auto px-6 py-5 flex justify-between items-center">
        <span className="text-2xl font-bold bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
          SteerFi
        </span>
        {showBack && onBack ? (
          <Button
            variant="ghost"
            onClick={onBack}
            className="px-0 h-auto bg-transparent hover:bg-transparent text-muted-foreground hover:text-foreground focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            ← Back
          </Button>
        ) : (
          showSignIn &&
          onSignIn && (
            <Button
              variant="outline"
              onClick={onSignIn}
              className="shadow-sm hover:shadow-md transition-shadow"
            >
              Sign In
            </Button>
          )
        )}
      </div>
    </header>
  );
};
